/* eslint-disable import/prefer-default-export */
const DarkThemeColors = [
  {
    name: 'BLUE_THEME',
    palette: {
      primary: {
        main: '#FF9B6E',
        light: '#4a3024',
        dark: '#E57A48',
        contrastText: '#0c1318',
      },
      secondary: {
        main: '#9B7AFF',
        light: '#3d2f6b',
        dark: '#7B5AE8',
        // Declared, because redeclaring `main` here drops the default's contrastText and
        // MUI then picks white, which is 3.17:1 on this violet. This is 6.19:1.
        contrastText: '#040433',
      },
      background: {
        default: '#111b21',
        dark: '#111b21',
        paper: '#202c33',
      },
    },
  },
  {
    name: 'AQUA_THEME',
    palette: {
      primary: {
        main: '#FF9B6E',
        light: '#4a3024',
        dark: '#E57A48',
        contrastText: '#0c1318',
      },
      secondary: {
        main: '#9B7AFF',
        light: '#3d2f6b',
        dark: '#7B5AE8',
        // Declared, because redeclaring `main` here drops the default's contrastText and
        // MUI then picks white, which is 3.17:1 on this violet. This is 6.19:1.
        contrastText: '#040433',
      },
      background: {
        default: '#111b21',
        dark: '#111b21',
        paper: '#202c33',
      },
    },
  },
  {
    name: 'PURPLE_THEME',
    palette: {
      primary: {
        main: '#FF9B6E',
        light: '#4a3024',
        dark: '#E57A48',
        contrastText: '#0c1318',
      },
      secondary: {
        main: '#9B7AFF',
        light: '#3d2f6b',
        dark: '#7B5AE8',
        // Declared, because redeclaring `main` here drops the default's contrastText and
        // MUI then picks white, which is 3.17:1 on this violet. This is 6.19:1.
        contrastText: '#040433',
      },
      background: {
        default: '#111b21',
        dark: '#111b21',
        paper: '#202c33',
      },
    },
  },
  {
    name: 'GREEN_THEME',
    palette: {
      primary: {
        main: '#FF9B6E',
        light: '#4a3024',
        dark: '#E57A48',
        contrastText: '#0c1318',
      },
      secondary: {
        main: '#9B7AFF',
        light: '#3d2f6b',
        dark: '#7B5AE8',
        // Declared, because redeclaring `main` here drops the default's contrastText and
        // MUI then picks white, which is 3.17:1 on this violet. This is 6.19:1.
        contrastText: '#040433',
      },
      background: {
        default: '#111b21',
        dark: '#111b21',
        paper: '#202c33',
      },
    },
  },
  {
    name: 'CYAN_THEME',
    palette: {
      primary: {
        main: '#FF9B6E',
        light: '#4a3024',
        dark: '#E57A48',
        contrastText: '#0c1318',
      },
      secondary: {
        main: '#9B7AFF',
        light: '#3d2f6b',
        dark: '#7B5AE8',
        // Declared, because redeclaring `main` here drops the default's contrastText and
        // MUI then picks white, which is 3.17:1 on this violet. This is 6.19:1.
        contrastText: '#040433',
      },
      background: {
        default: '#111b21',
        dark: '#111b21',
        paper: '#202c33',
      },
    },
  },
  {
    name: 'ORANGE_THEME',
    palette: {
      primary: {
        main: '#FF9B6E',
        light: '#4a3024',
        dark: '#E57A48',
        contrastText: '#0c1318',
      },
      secondary: {
        main: '#9B7AFF',
        light: '#3d2f6b',
        dark: '#7B5AE8',
        // Declared, because redeclaring `main` here drops the default's contrastText and
        // MUI then picks white, which is 3.17:1 on this violet. This is 6.19:1.
        contrastText: '#040433',
      },
      background: {
        default: '#111b21',
        dark: '#111b21',
        paper: '#202c33',
      },
    },
  },
];

// eslint-disable-next-line import/prefer-default-export
export { DarkThemeColors };
